import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const bonuses = [{
    number: 1,
    value: '$9.99',
    title: 'Rutina Sin Pantallas / Screen-Free Routine',
    description: 'Calendario de 7 días imprimible con actividades diarias de 15 a 30 minutos. Di adiós al tiempo de pantalla sin peleas ni llantos.'
  }, {
    number: 2,
    value: '$7.99',
    title: 'Certificados de Logro / Achievement Awards',
    description: 'Pack de 10 diplomas imprimibles y personalizables para motivar a tus hijos a completar cada actividad con orgullo.'
  }, {
    number: 3,
    value: '$12.99',
    title: "Guía para Padres / Parent's Guide",
    description: 'Todo lo que necesitas saber sobre qué habilidades desarrolla cada actividad según la edad de tu hijo. Con tips prácticos para acompañarlos.'
  }];
  return <section ref={ref} className="w-full bg-gradient-to-b from-white to-amber-50 py-16 md:py-20" data-id="element-23">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} className="text-center mb-12" data-id="element-25">
          <h2 className="font-fredoka text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-26">
            Y eso no es todo...
          </h2>
          <p className="font-fredoka text-2xl sm:text-3xl font-bold text-orange-600" data-id="element-27">
            Hoy incluye 3 BONOS GRATIS 🎁
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-28">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.2 * index,
          duration: 0.6
        }} className="bg-white border-2 border-orange-200 p-6 rounded-3xl shadow-lg relative overflow-hidden" data-id="element-29">
              <div className="absolute top-0 right-0 bg-orange-500 text-white px-4 py-2 rounded-bl-2xl font-fredoka font-bold" data-id="element-30">
                GRATIS
              </div>

              <div className="flex items-center gap-3 mb-4" data-id="element-31">
                <div className="bg-orange-100 p-3 rounded-full" data-id="element-32">
                  <Gift className="w-6 h-6 text-orange-600" data-id="element-33" />
                </div>
                <div data-id="element-34">
                  <p className="font-fredoka text-sm font-semibold text-gray-600" data-id="element-35">
                    BONO #{bonus.number}
                  </p>
                  <p className="font-nunito text-sm text-gray-500" data-id="element-36">
                    VALOR <span className="line-through" data-id="element-37">{bonus.value}</span>
                  </p>
                </div>
              </div>

              <h3 className="font-fredoka text-lg font-bold text-gray-900 mb-3" data-id="element-38">
                {bonus.title}
              </h3>
              <p className="font-nunito text-sm text-gray-700 leading-relaxed" data-id="element-39">
                {bonus.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}